import React from 'react';
import PropTypes from 'prop-types';

import { ContentVideoHeader } from './content-video-header';
import { ContentVideoDetail } from './content-video-detail';
import { ContentVideo } from './content-video';
import { Link } from 'react-router';
import PageTracker from 'src/app-lib/helpers/page-tracker';

export class ContentCard extends React.Component {
    constructor(props) {
        super(props);
    }

    getContentVideoHeader() {
        const contentVideoHeaderProps = {
            channelLogo: this.props.channelLogo,
            channelTitle: this.props.channelTitle,
            channelKey: this.props.channelKey,
            contentHeaderOnClickHandler: this.props.contentHeaderOnClickHandler,
            isFetching: this.props.isFetching
        };
        return (<ContentVideoHeader {...contentVideoHeaderProps} />);
    }

    getContentVideoAndDetail() {
        const contentVideoProps = {
            contentDuration: this.props.contentDuration,
            contentThumbnail: this.props.contentThumbnail,
            contentOnClickHandler: this.props.contentOnClickHandler,
            isFetching: this.props.isFetching
        };
        const contentVideoDetailProps = {
            contentCategory: this.props.contentCategory,
            contentTitle: this.props.contentTitle,
            contentPublishDate: this.props.contentPublishDate,
            numOfViews: this.props.numOfViews,
            isFetching: this.props.isFetching
        };
        return (<div className="content-card__onclick" onClick={this.props.contentOnClickHandler.bind(this)}>
            <ContentVideo {...contentVideoProps} />
            <ContentVideoDetail {...contentVideoDetailProps} />
        </div>);
    }

    displayContentCard() {
        const { channelKey, contentKey, animationType} = this.props;
        // pass channelkey and contentKey to DOM to help automation test
        return (<div
          className={`content-card animated ${animationType}`}
          data-channelkey={`${channelKey}`}
          data-contentkey={`${contentKey}`}
        >
            {this.getContentVideoHeader()}
            {channelKey && contentKey ?
                <Link to={{pathname: `/channel/${channelKey}/recording/${contentKey}/watch`, search: `?source=${PageTracker.lastPage}`}}>
                {this.getContentVideoAndDetail()}
                </Link> :
                this.getContentVideoAndDetail()}
        </div>);
    }

    render() {
        return (this.displayContentCard());
    }
}

ContentCard.propTypes = {
    contentKey: PropTypes.string,
    channelKey: PropTypes.string,
    channelLogo: PropTypes.string,
    channelTitle: PropTypes.string.isRequired,
    contentDuration: PropTypes.number,
    contentThumbnail: PropTypes.string,
    contentOnClickHandler: PropTypes.func,
    contentHeaderOnClickHandler: PropTypes.func,
    contentCategory: PropTypes.string,
    contentTitle: PropTypes.string.isRequired,
    contentPublishDate: PropTypes.string.isRequired,
    numOfViews: PropTypes.string,
    isFetching: PropTypes.number,
    animationType: PropTypes.string
};

ContentCard.defaultProps = {
    animationType: 'fadeIn',
    contentKey: null,
    channelKey: null,
    channelLogo: null,
    channelTitle: null,
    contentDuration: null,
    contentThumbnail: null,
    contentOnClickHandler: PropTypes.func,
    contentHeaderOnClickHandler: PropTypes.func,
    contentCategory: PropTypes.string,
    contentTitle: null,
    contentPublishDate: null,
    numOfViews: null,
    isFetching: null
};



// WEBPACK FOOTER //
// ./src/components/SharedComponents/content/content-card.js